import { render, staticRenderFns } from "./TabData.vue?vue&type=template&id=56fbfb28&scoped=true&"
import script from "./TabData.vue?vue&type=script&lang=js&"
export * from "./TabData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fbfb28",
  null
  
)

export default component.exports